module.exports = __webpack_public_path__ + "img/group.2837fc3b.svg";